import { useQuery } from '@hooks/reactQuery';

import { getConnectionLogsNames } from '@api/networkElements';

import { extractQueryParams } from '@utils/common';
import { optionsFormattedWithArray } from '@utils/formatter';

import { IOrganizationId } from '@interfaces/common/common';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENTS_NAMES_OPTIONS } from '@constants/queryKeys';

interface IUseQueryNetworkElementsNamesReturned {
	namesOptions: TSelectOption[];
	isLoadingNamesOptions: boolean;
}

const useQueryNetworkElementsNames = (params: Partial<IOrganizationId>): IUseQueryNetworkElementsNamesReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [NETWORK_ELEMENTS_NAMES_OPTIONS, params],
		queryFn: extractQueryParams(getConnectionLogsNames),
		select: (data) => optionsFormattedWithArray(data?.names || []),
		allowedRoles: [EUserRoles.smoLightUpdater, EUserRoles.smoLightViewer],
		...refetchOptions,
	});

	return {
		namesOptions: data || [],
		isLoadingNamesOptions: (isLoading && !!data) || isFetching,
	};
};

export default useQueryNetworkElementsNames;
